import { render, staticRenderFns } from "./divider-item.vue?vue&type=template&id=cb3bb200&scoped=true&"
import script from "./divider-item.vue?vue&type=script&lang=js&"
export * from "./divider-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3bb200",
  null
  
)

export default component.exports